var doNothing = function () {
};

module.exports = (console && console.log) ? console.log : doNothing;



//////////////////
// WEBPACK FOOTER
// ./lib/utils/logger.js
// module id = 23
// module chunks = 0